<template>
    <div class="spring">
        <h2 class="heading heading--4 heading--light heading--leading heading--center">Tarife standard</h2>
        <div class="mb-2 text-center">Tarifele se aplică pentru contractele încheiate după data de 7 Iunie 2023</div>
        <br />
        <card-tarifs-columns :data="GET_COUNTRY_GROUP_DATA"></card-tarifs-columns>
        <div class="mb-2">Consulta <a style="text-decoration: underline" target="_blank" rel="noopener noreferrer" href="https://www.vodafone.ro/personal/servicii-si-tarife/termeni-si-proceduri-legale/conditiile-de-furnizare-a-serviciilor/index.htm">aici</a> tarifele aplicabile abonamentului tau în funcție de data activarii/reinnoirii acestuia.</div>
    </div>
</template>

<script>
import CardTarifsColumns from './CardTarifsColumns.vue';
export default {
    name: 'PostPaidCardsOffers',
    props: ['countryGroup'],
    components: {
        CardTarifsColumns,
    },
    data() {
        return {
            default_offers: [
                {
                    groupID: 1,
                    tarif_internet_pachet: '4000 MB/ 18 &euro;',
                    tarif_voce_pachet: '30 min / 7 &euro;',
                    tarif_apel_efectuat: '1 &euro;/min',
                    tarif_sms_trimis: '0.25 &euro;/SMS',
                },
                {
                    groupID: 2,
                    tarif_internet_pachet: '3000 MB/ 30 &euro;',
                    tarif_voce_pachet: '30 min / 15 &euro;',
                    tarif_apel_efectuat: '2 &euro;/min',
                    tarif_sms_trimis: '0.50 &euro;/SMS',
                },
                {
                    groupID: 3,
                    tarif_internet_pachet: 'Serviciu indisponibil',
                    tarif_voce_pachet: '30 min / 15 &euro;',
                    tarif_apel_efectuat: '2 &euro;/min',
                    tarif_sms_trimis: '0.50 &euro;/SMS',
                },
            ],
        };
    },
    computed: {
        GET_COUNTRY_GROUP_DATA() {
            if (!this.countryGroup) return {};
            else {
                return this.default_offers.find((group) => {
                    return group.groupID === this.countryGroup;
                });
            }
        },
    },
};
</script>
